'use es6';

import { PARTNER_SERVICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const PartnerService = ObjectDefinitionRecord({
  hasAccess: (_isUngated, hasScope) => hasScope('partner-service-object-read'),
  objectTypeId: PARTNER_SERVICE_TYPE_ID,
  referenceObjectType: 'PARTNER_SERVICE_PROPERTIES'
});
export default PartnerService;